import React from 'react';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useEnableCm6PackingSlipEditor } from '../../feature-flags/hooks/use-enable-cm6-packing-slip-editor';

const CodeMirror5Editor = React.lazy(() => import('./codemirror.editor').then((module) => ({ default: module.CodeMirrorEditor })));

const CodeMirror6Editor = React.lazy(() =>
  import('./codemirror6/codemirror6-editor').then((module) => ({ default: module.CodeMirror6Editor })),
);

/**
 * @param {object} props
 * @param {(content: string) => void} props.onChange
 * @param {string} props.value
 * @param {keyof typeof import('./constants').FIELD_REPLACEMENT_SETS} props.replacementSet
 * @returns {React.JSX.Element}
 */
export const LazyCodeEditor = (props) => {
  const useCodeMirror6 = useEnableCm6PackingSlipEditor();
  const EditorComponent = useCodeMirror6 ? CodeMirror6Editor : CodeMirror5Editor;

  return (
    <React.Suspense fallback={<LoadingIndicator />}>
      <EditorComponent {...props} />
    </React.Suspense>
  );
};
